import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  startLoading,
  stopLoading,
} from "../../../controllers/reducers/loader";
import { addToCart, IProduct } from "../../../controllers/reducers/cart";
import { api } from "../../../controllers/api";
import { RootState } from "../../..";
import Image from "../../home/components/Image";
import { NavLink } from "react-router-dom";

interface IWishitem {
  product: IProduct;
  customerId: string;
  _id: string;
  productId: string;
}
function Wishlist() {
  let [wishList, setWishList] = useState<IWishitem[]>([]); // Dummy wishlist data
  let dispatch = useDispatch();
  let [limit, setLimit] = useState(20);
  const { user, cart } = useSelector((state: RootState) => state);
  let [skip, setSkip] = useState(0);
  const [inCart, setInCart] = useState(false);
  const checkCart = (id: string, cart: any[]): boolean => {
    let exist = false;
    for (let x = 0; x < cart.length; x++) {
      if (cart[x].product._id === id) {
        exist = true;
        // cartIndex = x;
        //     setQuantity(cart[x].quantity);
        setInCart(true);
        break;
      }
    }
    return exist;
  };
  let handleGetWishes = async () => {
    dispatch(startLoading());
    try {
      let req = await fetch(`${api}/wishlist/${skip}/${limit}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${user?.token}` },
      });
      if (req.ok) {
        let res = await req.json();
        console.log("res", res);
        setWishList(res);
      }
    } catch (error) {
      alert("Error fetching wishlist");
      console.log(error);
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleDeleteWish = async (id: string) => {
    try {
      dispatch(startLoading());
      let request = await fetch(api + "/wishlist/" + id, { method: "DELETE" });
      if (request.ok) {
        await handleGetWishes();
      }
    } catch (e) {
      console.log();
    } finally {
      dispatch(stopLoading());
    }
  };
  useEffect(() => {
    handleGetWishes();
  }, []);
  const handleAddToCart = async (wishItem: IWishitem) => {
    const { product } = wishItem;
    if (!user) {
      // navigate("/auth/login", { state: location.
      return;
    } else if (!checkCart(product._id!!, cart.cart)) {
      dispatch(startLoading());

      try {
        let req = await fetch(`${api + "/cart"}`, {
          body: JSON.stringify({
            product: {
              _id: product._id,
              name: product.brand_name,
              price: product.price ?? 0,
              //@ts-ignore())
              image: product.images[0],
              expiry_date: product.expiry_date,
              merchant_id: product.merchant_id,
              company: product.company,
            },
            product_id: product._id,
            price: product.price ?? 0,
            quantity: 1,
            date_added: new Date().toISOString(),
          }),
          method: "POST",
          headers: {
            AUthorization: "Bearer " + user?.token,
            "Content-type": "application/json",
          },
        });
        if (req.ok) {
          let newCart = await req.json();
          checkCart(product._id!!, newCart.cart);
          setInCart(true);
          dispatch(addToCart(newCart));
          handleDeleteWish(wishItem._id);
        }
        dispatch(stopLoading());
      } catch (error) {
        alert("something went wrong");
        dispatch(stopLoading());
      }
    } else handleDeleteWish(wishItem._id);
  };
  return (
    <div className="wishlist-con">
      <h3>Wishlist ({wishList.length})</h3>
      <section>
        {wishList.map((wishItem) => (
          <WishlistCard
            deleteWish={handleDeleteWish}
            addToCart={handleAddToCart}
            wishItem={wishItem}
          />
        ))}
      </section>
    </div>
  );
}

export default Wishlist;

function WishlistCard({
  wishItem,
  deleteWish,
  addToCart,
}: {
  wishItem: IWishitem;
  addToCart: (wishItem: IWishitem) => void;
  deleteWish: (id: string) => void;
}) {
  return (
    <div className="wishlist-con__card">
      <div className="wishlist-con__card__main">
        <Image
          brand_name={wishItem.product.brand_name}
          images={wishItem.product.images}
          key={wishItem.productId}
        />
        <div className="wishlist-con__card__details">
          <p className="wishlist-con__card__details__name">
            {wishItem.product.name}
          </p>
          <NavLink to={"/all?brand=" + wishItem.product.company}>
            {wishItem.product.company}
          </NavLink>
          <NavLink to={"/merchant/" + wishItem.product.merchant_id}>
            {wishItem.product.merchant}
          </NavLink>{" "}
          <p>&#8358;{wishItem.product.price}</p>
        </div>
      </div>
      <div className="wishlist-con__card__footer">
        <button onClick={() => deleteWish(wishItem._id)}>Remove</button>
        <button onClick={() => addToCart(wishItem)}>Add to Cart</button>
      </div>
    </div>
  );
}
